import { DatePicker, Form, Input, InputNumber, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { labelComponent } from "../../util/UtilComponents";
import { useSelector } from "react-redux";
import { isArrayNonEmpty } from "../../util/ApiHelper";
import TextArea from "antd/lib/input/TextArea";
import { isBuyer, isExporter } from "../../util/helper";

const BuyerOfferProductModal = ({
  visible,
  onCancel,
  onSave,
  form,
  initialValues = {},
  isNegotiation = false,
  selectedCurrencies = ["INR"],
  loading = false,
}) => {
  const { Option } = Select;
  const countries = useSelector(({ common }) => common.countries);
  const ports = useSelector(({ common }) => common.ports);
  const [selectedDestinationCountry, setSelectedDestinationCountry] =
    useState(null);
  const [destinationPortsData, setDestinationPortsData] = useState([]);
  const handleChangeDestinationCountry = (value) => {
    setSelectedDestinationCountry(value);
    form.resetFields(["destinationPort"]);
  };
  let isEditDisabled = false;
  const userData = useSelector(({ auth }) => auth?.userData);

  const FOR_DESTINATIONS = [
    "Mundra Port",
    "Nhava Sheva",
    "Kakinada",
    "Gandhidham",
    "Chennai",
  ];

  const validatePortSelection = async (_, value) => {
    const sourcePort = form.getFieldValue("sourcePort");
    if (value === sourcePort) {
      throw new Error("Source Port and Destination Port cannot be the same");
    }
    return;
  };
  useEffect(() => {
    if (
      selectedDestinationCountry &&
      isArrayNonEmpty(countries) &&
      isArrayNonEmpty(ports)
    ) {
      const country = countries.find(
        (item) => item.country === selectedDestinationCountry
      );

      if (country) {
        const filteredPorts = ports.filter(
          (item) =>
            item.countryName &&
            item.countryName.trim().toLowerCase() ===
              country.country.trim().toLowerCase()
        );
        setDestinationPortsData(filteredPorts);
      } else {
        setDestinationPortsData([]);
      }
    } else {
      setDestinationPortsData([]);
    }
  }, [selectedDestinationCountry, countries, ports]);
  return (
    <Modal
      title={
        <span style={{ fontSize: "20px", fontWeight: "bold" }}>
          {isNegotiation ? "Negotiate Offer" : "Block the Rate"}
        </span>
      }
      open={visible}
      onOk={onSave}
      onCancel={onCancel}
      okText="Submit"
      cancelText="Cancel"
      width={650}
      className="custom-modal"
      confirmLoading={loading}
    >
      <Form
        form={form}
        layout="horizontal"
        initialValues={{
          ...initialValues,
        }}
        labelCol={{
          span: 8,
          style: { textAlign: "left", paddingRight: "8px" },
        }}
        wrapperCol={{
          span: 16,
        }}
        labelAlign="left"
      >
        <Form.Item
          label={<span style={{ fontWeight: "bold" }}>Required Quantity</span>}
          name="noOfUnits"
          required
          colon={false}
        >
          <Input.Group
            compact
            style={{ display: "flex", alignItems: "stretch" }}
          >
            <Form.Item
              name="noOfUnits"
              noStyle
              rules={[
                {
                  required: true,
                  message: "Please enter quantity",
                  validator: (_, value) =>
                    value > 0
                      ? Promise.resolve()
                      : Promise.reject("Quantity must be given"),
                },
              ]}
              required={false}
            >
              <InputNumber
                style={{ flex: 1, minWidth: "50%" }}
                min={0}
                controls={false}
                placeholder="Enter Quantity"
              />
            </Form.Item>
            <Form.Item name="uom" noStyle>
              <Input
                style={{
                  flex: 1,
                  minWidth: "50%",
                  backgroundColor: "#f5f5f5",
                  color: "rgba(0, 0, 0, 0.85)",
                  cursor: "not-allowed",
                  height: "100%",
                }}
                disabled
                value={form.getFieldValue("uom")}
              />
            </Form.Item>
          </Input.Group>
        </Form.Item>
        {isExporter(userData) && (
          <Form.Item
            label={labelComponent(
              <span style={{ fontWeight: "bold" }}>Delivery Location</span>
            )}
            name="deliveryLocation"
            rules={[
              { required: true, message: "Delivery Location is required" },
            ]}
          >
            <Select
              placeholder="Select Delivery Location"
              showSearch
              size="large"
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {FOR_DESTINATIONS.map((destinationPort) => (
                <Option key={destinationPort} value={destinationPort}>
                  {destinationPort}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        {isExporter(userData) && (
          <Form.Item
            label={labelComponent(
              <span style={{ fontWeight: "bold" }}>Expected loading date</span>
            )}
            name="expectedLoadingDate"
            rules={[
              { required: true, message: "Expected loading date is required" },
            ]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="DD-MM-YYYY"
              placeholder="Expected Loading date"
              allowClear={true}
              getPopupContainer={(trigger) => trigger.parentNode}
            />
          </Form.Item>
        )}

        {isBuyer(userData) && (
          <Form.Item
            disabled={isEditDisabled}
            label={labelComponent(
              <span style={{ fontWeight: "bold" }}>Destination Country</span>,
              "Select the Destination Country where Goods to be Delivered"
            )}
            name="destinationCountry"
            rules={[
              {
                required: true,
                message: "Destination Country is required",
              },
            ]}
          >
            <Select
              showSearch
              size="large"
              placeholder="Select Destination Country"
              onChange={handleChangeDestinationCountry}
              value={selectedDestinationCountry}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {countries?.map((option) => (
                <Option key={option.country} value={option.country}>
                  {option.country}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}
        {isBuyer(userData) && (
          <Form.Item
            disabled={isEditDisabled}
            label={labelComponent(
              <span style={{ fontWeight: "bold" }}>Destination Port</span>,
              "Select the Destination Port where Goods to be Delivered"
            )}
            name="destinationPort"
            rules={[
              {
                required: true,
                message: "Destination Port is required",
              },
              { validator: validatePortSelection },
            ]}
          >
            <Select
              showSearch
              size="large"
              placeholder="Select Destination Port"
              disabled={!selectedDestinationCountry}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              getPopupContainer={(trigger) => trigger.parentNode}
              name="destinationPort"
              rules={[
                {
                  required: true,
                  message: "Destination Port is required",
                },
              ]}
            >
              {destinationPortsData.map((option) => (
                <Option key={option.port} value={option.port}>
                  {`${option.port} (${option.code})`}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}
        {isNegotiation && (
          <Form.Item
            required
            label={<span style={{ fontWeight: "bold" }}>Expected Price</span>}
            colon={false}
            labelCol={{
              span: 8,
              style: { textAlign: "left", paddingRight: "8px" },
            }}
            wrapperCol={{
              span: 16,
            }}
          >
            <Input.Group compact style={{ display: "flex", width: "100%" }}>
              {/* Currency Select */}
              <Form.Item
                name="currency"
                noStyle
                initialValue="USD"
                rules={[
                  { required: true, message: "Please select a currency" },
                ]}
              >
                <Select
                  showSearch
                  size="large"
                  style={{
                    width: "25%",
                    borderRadius: "8px 0 0 8px",
                    borderRight: "none",
                  }}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {[
                    ...new Set([
                      ...selectedCurrencies,
                      ...(countries
                        ?.filter((c) => c.currencyCode)
                        .map((c) => c.currencyCode) || []),
                    ]),
                  ].map((currencyCode) => (
                    <Option key={currencyCode} value={currencyCode}>
                      {currencyCode}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              {/* Rate Input - Reduced width */}
              <Form.Item
                name="negotiatePricePerUnit"
                noStyle
                rules={[
                  {
                    required: true,
                    message: "Please enter rate",
                    validator: (_, value) =>
                      value > 0
                        ? Promise.resolve()
                        : Promise.reject("Rate must be > 0"),
                  },
                ]}
              >
                <InputNumber
                  style={{
                    width: "35%",
                    borderRadius: 0,
                    borderLeft: "none",
                    borderRight: "none",
                  }}
                  placeholder="Enter rate"
                  step={0.01}
                  formatter={(value) =>
                    value
                      ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : ""
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  controls={false}
                />
              </Form.Item>

              {/* Slash Separator */}
              <div
                style={{
                  width: "5%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  borderTop: "1px solid #d9d9d9",
                  borderBottom: "1px solid #d9d9d9",
                  color: "rgba(0,0,0,0.45)",
                  fontSize: "14px",
                }}
              >
                /
              </div>

              {/* UOM Display - Increased width */}
              <Form.Item noStyle>
                <Input
                  //   disabled
                  value={form.getFieldValue("uom") || ""}
                  style={{
                    width: "35%", // Increased from 25% to 35%
                    cursor: "not-allowed",
                    borderRadius: "0 8px 8px 0",
                    borderLeft: "none",
                    textAlign: "center",
                  }}
                />
              </Form.Item>
            </Input.Group>
          </Form.Item>
        )}

        <Form.Item
          disabled={isEditDisabled}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          label={<span style={{ fontWeight: "bold" }}>Comments</span>}
          name="comment"
          rules={[{ required: true, message: "Please enter Comments" }]}
        >
          <TextArea
            disabled={isEditDisabled}
            rows={3}
            placeholder="Add any additional requirements or special conditions for this order"
            showCount
            maxLength={250}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BuyerOfferProductModal;
